export const BUSINESS = {
  name: 'Xpress Lube & Tune',
  phone: '+17148792287',
  phoneFormatted: '(714) 879-2287',
  address: {
    street: '461 E Imperial Hwy',
    city: 'La Habra',
    state: 'CA',
    zip: '90631',
    full: '461 E Imperial Hwy, La Habra, CA 90631',
  },
  hours: {
    weekdays: 'Mon-Fri: 7AM - 5PM',
    saturday: 'Sat: 7AM - 4PM',
    sunday: 'Sun: Closed',
  },
  email: null,
  website: 'https://xpresslubeandtune.com',
  // TODO: Update with actual Google Maps URL
  googleMapsUrl: 'https://maps.google.com/?q=461+E+Imperial+Hwy+La+Habra+CA+90631',
  yelpUrl: 'https://www.yelp.com/biz/xpress-lube-and-tune-la-habra',
  rating: '4.2',
  googleReviewCount: '53',
  yelpReviewCount: '84',
  reviewCount: '137',
  tagline: "La Habra's Express Oil Change & Auto Repair -- Family Owned",
  owner: 'Jose',
  team: ['Jose', 'Albert', 'Edwin'],
  languages: ['English', 'Spanish'],
}
